var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search_form" },
    [
      _c(
        "div",
        { staticClass: "search_filed" },
        [
          _c(
            "b-input-group",
            [
              _c(
                "b-input-group-text",
                { attrs: { slot: "prepend" }, slot: "prepend" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.__t("FIND_GROUP")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("b-form-input", {
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-overlay",
        { attrs: { show: _vm.is_load } },
        [_c("groups_list", { attrs: { groups: _vm.grouplist } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }